import React from 'react'
import './contactenosLanding.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHouseUser } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faTwitter, faInstagram, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons';

const ContactenosLanding = () => {
    return (
        <>
            <div className='div-container-landing'>
                <div className='div-titulo-contactenos'>
                    <h1 className='size-landing-h1'>
                        Contáctanos
                    </h1>
                    <p className='p-element-target-landing-2 margin-15' >
                        Estamos aquí para ayudarte. Soporte profesional en todo momento para nuestros clientes.
                    </p>
                </div>

                <div className="contact-cards">
                    <div className="contact-card">
                        <div className="icon-container">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </div>
                        <h3>Email</h3>
                        <p>Escríbenos y te responderemos en 24 horas</p>
                        <span className="highlight">servicios@agendate.com</span>
                    </div>
                    <div className="contact-card">
                        <div className="icon-container">
                            <FontAwesomeIcon icon={faWhatsapp} />
                        </div>
                        <h3>Chat</h3>
                        <p>Lunes a Viernes</p>
                        <p>de 9:00 am a 6:00 pm</p>
                        <span className="highlight">+57 300 4790612</span>
                    </div>

                    <div className="contact-card">
                        <div className="icon-container">
                            <FontAwesomeIcon icon={faHouseUser} />
                        </div>
                        <h3>Oficina</h3>
                        <p>Visítanos en nuestras oficinas</p>
                        <span className="highlight">
                            Carrera 11 B # 99 - 25 <br />
                            Bogotá - Colombia
                        </span>
                        <p style={{ fontSize: '12px', marginTop: '0.5rem' }}>*Cita previa*</p>
                    </div>
                </div>
                <div className="support-social-container">
                    <div className="support-buttons">
                        <button className="bottom-custom">
                            Solicitar Soporte
                        </button>
                        <button className="bottom-custom-secondary">Renovar Suscripción</button>
                    </div>

                    <div className="social-section">
                        <h2>Síguenos en Redes Sociales</h2>
                        <p>Mantente actualizado con nuestras últimas noticias y actualizaciones</p>

                        <div className="social-icons">
                            <FontAwesomeIcon icon={faYoutube} className='social-icon' />
                            <FontAwesomeIcon icon={faLinkedinIn} className='social-icon' />
                            <FontAwesomeIcon icon={faInstagram} className='social-icon' />
                            <FontAwesomeIcon icon={faTwitter} className='social-icon' />
                        </div>
                    </div>
                </div>
            </div> </>
    )
}

export default ContactenosLanding